import { SettingsApiTypes } from "@rshbintech.dboul/http";

export const getMenuItemsSettings = (
  clientSettings: SettingsApiTypes.ClientSettings
) => {
  if (!Array.isArray(clientSettings?.settings?.frontend)) {
    return [];
  }

  const menuItemsSettings = clientSettings.settings.frontend.filter(
    (setting) =>
      setting.systemId === "Отображение пунктов меню" &&
      typeof setting.value === "string" &&
      setting?.value?.length > 0
  );

  const menuItemsSettingsWithLowerCase = menuItemsSettings.map(
    (menuItemSetting) => ({
      ...menuItemSetting,
      value: menuItemSetting.value?.toLowerCase(), // INFO: Меняем возможные значения FALSE на false, из-за потенциальной ошибки при загрузке файла с клиентами
    })
  );

  return menuItemsSettingsWithLowerCase;
};
